import { faTable as faTableLight } from '@fortawesome/pro-light-svg-icons'
import { Toggle } from './toggle'

export const TableToggle = ({
  className,
  isOn,
  iconOn,
  iconOff,
  tooltipOn,
  tooltipOff,
  onChange
}) => {
  return <Toggle
    data-qa="control-bar-table-toggle"
    className={className}
    isOn={isOn}
    iconOn={iconOn || faTableLight}
    tooltipOn={tooltipOn || 'Hide Table'}
    iconOff={iconOff || faTableLight}
    tooltipOff={tooltipOff || 'Show Table'}
    onChange={onChange}
  />
}
